import httpClient from "lc-http";
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";
import { staticConstants as constants } from "../../constants-ui";
import PI1FormSecAmount from "./PI1FormSecAmount";
import PI1FormNameAddress from "./PI1FormNameAddress";
import PI1FormSecDetails from "./PI1FormSecDetails";
import PI1FormSecActions from "./PI1FormSecActions";
import Disclosures from "./Disclosures";
import { Spinner } from "@pf-loan-funnel/pf-component-library";
import { getFormMetadata } from "./services/pi1-form-metadata";
import { determineLoanTypes } from "./services/pi1-form-validation-loan-amt";

let timeoutID;
export const REQUIRED_EMPLOY_DETAILS = ["EMPLOYED", "OTHER", "SELFEMPLOYED"];

class PI1FormReact extends Component {
  constructor(props) {
    super(props);

    const {
      clientInfo: { inEmailVerificationPilot },
      clientProds,
      defaultValues,
      userInfo,
      shouldCollectEmploymentStatus,
    } = props;

    this.state = {
      hasSubmittedBE: false,
      hasInvalidFields: false,
      validateAllFields: false,
      hasErrored: false,
      hasReqTimeout: false,
      hasErroredUnrecoverable: false,
      hasCompletedBE: false,
      nameDisabled: true,
      MAStateSelected: false,
      zeroIncomes: false,
      validForm: false,
      hasAutoFilled: false,
      hasValidated: false,
      formMetadata: getFormMetadata(
        userInfo,
        defaultValues,
        clientProds,
        inEmailVerificationPilot,
        shouldCollectEmploymentStatus,
      ),
      // next two async state are used just for 'email is uniq'
      hasCheckedAsyncFields: false,
      waitForAsyncCheck: false,
      minLoanAmt: clientProds.minGeneralAmount,
      maxLoanAmt: clientProds.maxGeneralAmount,
    };
  }

  static defaultProps = {
    pi1FormId: "pf-registration-form",
    errors: {},
    userInfo: {},
    clientInfo: { id: 0, inEmailVerificationPilot: false },
    clientProds: determineLoanTypes(),
    siteConfig: {},
    formClasses: {
      layout: "lo-form",
      hasSubmitted: "form-submitted",
      hasErrored: "form-errored",
      hasInvalidFields: "form-invalid",
      hasCompleted: "form-completed",
    },
    shouldRender: false,
    updates: {
      // front end catches incorrect fields
      invalidFieldsMsg: "Oops, please fill in all form fields correctly.",
      // 400 API response
      errorMsg:
        "Oops! There was an error submitting the form. Please review your form entries and resubmit the form.",
      // form submit time out
      errorTimeoutMsg:
        "Oops! There was an error submitting the form. Please try to submit again in a few moments. If this error occurs again, please call us at (800) 630-1663 so we can assist.",
      // 500 API response
      unrecoverableMsg:
        "Our system is currently down so we had trouble processing your application. Please call us at (800) 630-1663 so we can assist.",
      successMsg: "Success! The form submission completed.",
    },
  };

  static getDerivedStateFromProps(props, state) {
    const { hasAutoFilled } = state;
    const {
      clientInfo: { inEmailVerificationPilot },
      clientProds,
      defaultValues,
      userInfo,
      shouldCollectEmploymentStatus,
    } = props;

    // check for autoFill usage only once, then not again
    if (!hasAutoFilled && defaultValues && defaultValues.isAutoFill) {
      const formData = getFormMetadata(
          userInfo,
          defaultValues,
          clientProds,
          inEmailVerificationPilot,
          shouldCollectEmploymentStatus,
        ),
        objKeys = Object.keys(formData).length;

      if (objKeys && objKeys > 0) {
        for (const section in formData) {
          if (formData.hasOwnProperty(section)) {
            formData[section].isValid = true;
          }
        }

        return { formMetadata: formData, hasAutoFilled: true };
      }
    }

    return null;
  }

  componentWillUnmount() {
    clearTimeout(timeoutID);
  }

  componentDidMount() {
    const self = this;
    setTimeout(() => {
      const { formMetadata } = self.state;
      const ev = {
        target: { value: formMetadata.sectionAmount.fields.relationship.value },
      };
      self.toggleApplicantName(ev);
    }, 100);
  }

  updateMinMaxLoanAmt = () => {
    const { clientProds } = this.props,
      { formMetadata } = this.state,
      loanAmount = formMetadata.sectionAmount.fields.loanAmount.value
        ? parseInt(formMetadata.sectionAmount.fields.loanAmount.value, 10)
        : null;
    const minVal =
      this.state.MAStateSelected && clientProds.useMinAmountForMA
        ? clientProds.MAMinAmount
        : clientProds.minGeneralAmount;

    if (
      !loanAmount ||
      loanAmount < minVal ||
      loanAmount > this.state.maxLoanAmt
    ) {
      formMetadata.sectionAmount.fields.loanAmount.isValid = false;
      formMetadata.sectionAmount.fields.loanAmount.status = "invalid";
    } else {
      formMetadata.sectionAmount.fields.loanAmount.isValid = true;
      formMetadata.sectionAmount.fields.loanAmount.status = "";
    }

    formMetadata.sectionAmount.isValid = this.updateSectionInfo(
      formMetadata.sectionAmount.fields,
    );

    this.setState({ formMetadata, minLoanAmt: minVal });
  };

  handleStateChgCallback = (id, { home, mail }) => {
    this.setState(
      {
        MAStateSelected:
          home.state.value === "MA" || mail?.state?.value === "MA",
      },
      () => {
        this.updateMinMaxLoanAmt(this.state.MAStateSelected);
      },
    );
  };

  toggleApplicantName = (ev) => {
    const value = parseInt(ev.target.value, 10),
      SELF = 6, // recipient = applicant
      { formMetadata } = this.state;

    let nameDisabled = true,
      recipientFN = formMetadata.sectionAmount.fields.recipientFN.value.trim(),
      recipientLN = formMetadata.sectionAmount.fields.recipientLN.value.trim(),
      applicantFN = formMetadata.sectionAddress.fields.applicantFN.value.trim(),
      applicantLN = formMetadata.sectionAddress.fields.applicantLN.value.trim();

    if (value !== SELF) {
      nameDisabled = false;
      formMetadata.sectionAddress.fields.applicantFN.isRequired = true;
      formMetadata.sectionAddress.fields.applicantLN.isRequired = true;

      if (applicantFN === recipientFN) {
        formMetadata.sectionAddress.fields.applicantFN.value = "";
      }

      if (applicantLN === recipientLN) {
        formMetadata.sectionAddress.fields.applicantLN.value = "";
      }
    } else {
      formMetadata.sectionAddress.fields.applicantFN.value = recipientFN;
      formMetadata.sectionAddress.fields.applicantLN.value = recipientLN;
      formMetadata.sectionAddress.fields.applicantFN.isRequired = false;
      formMetadata.sectionAddress.fields.applicantLN.isRequired = false;
    }

    this.setState({
      formMetadata,
      nameDisabled,
    });
  };

  handleAddrToggleCallback = (secName, isSameAddr) => {
    const { formMetadata } = this.state,
      isRequired = isSameAddr.toLowerCase() === "no" ? true : false;

    formMetadata[secName].fields.address.isSameAddr = isSameAddr;
    for (const field in formMetadata[secName].fields.address.mail) {
      if (field !== "aptsuite") {
        formMetadata[secName].fields.address.mail[field].isRequired =
          isRequired;
      }
    }

    this.setState({ formMetadata });
  };

  isValidForm = () => {
    const { formMetadata } = this.state,
      secKeysToValidate = [
        "sectionAddress",
        "sectionAmount",
        "sectionDetails",
        "sectionDisclosures",
      ]; // some pi1 formMetadata we don't assign isValid to

    formMetadata.sectionAddress.isValid = this.updateSectionInfo(
      formMetadata.sectionAddress.fields,
    );
    formMetadata.sectionDetails.isValid = this.updateSectionInfo(
      formMetadata.sectionDetails.fields,
    );
    formMetadata.sectionDisclosures.isValid = this.updateSectionInfo(
      formMetadata.sectionDisclosures.fields,
    );
    formMetadata.sectionAmount.isValid = this.updateSectionInfo(
      formMetadata.sectionAmount.fields,
    );

    const validForm = secKeysToValidate.every((secName) => {
      const valid = formMetadata[secName].isValid === true;
      return valid;
    });

    return validForm;
  };

  isValidAddress = (address) => {
    for (const addrType in address) {
      if (address.hasOwnProperty(addrType)) {
        const fields = address[addrType];
        for (const field in fields) {
          if (fields.hasOwnProperty(field)) {
            if (field !== "isSameAddr") {
              const f = fields[field];
              if (f.isRequired && !f.isValid) {
                return false;
              }
            }
          }
        }
      }
    }
    return true;
  };

  updateSectionInfo = (sectionFields) => {
    for (const field in sectionFields) {
      if (sectionFields.hasOwnProperty(field)) {
        const f = sectionFields[field];
        if (field !== "address") {
          if (f.isRequired && !f.isValid ) {
            return false;
          }
        } else {
          return this.isValidAddress(f);
        }
      }
    }
    return true;
  };

  updateAsyncState = (data) => {
    // currently, specific to only current async test, email
    const { shouldWait, asyncComplete } = data.email;

    this.setState({
      waitForAsyncCheck: shouldWait,
      hasCheckedAsyncFields: asyncComplete,
    });
  };

  handleSectionCallback = (sectionName, fieldName, data) => {
    const { formMetadata, nameDisabled } = this.state;
    let zeros = false;

    formMetadata[sectionName].fields[fieldName] = data;
    if (
      !nameDisabled &&
      (fieldName === "applicantFN" || fieldName === "applicantLN")
    ) {
      formMetadata[sectionName].fields[fieldName].isRequired = true;
    }

    if (sectionName === "sectionAmount" && nameDisabled) {
      if (fieldName === "recipientFN") {
        formMetadata.sectionAddress.fields.applicantFN.value = data.value;
      } else if (fieldName === "recipientLN") {
        formMetadata.sectionAddress.fields.applicantLN.value = data.value;
      }
    }

    if (fieldName === "income") {
      const income = data.value ? parseInt(data.value, 10) : "";

      if (income === 0) {
        formMetadata[sectionName].fields[fieldName].isRequired = true;
        formMetadata[sectionName].fields[fieldName].isValid = false;
        formMetadata[sectionName].fields[fieldName].status = "invalid";
        zeros = true;
      } else if (income > 0) {
        formMetadata[sectionName].fields[fieldName].isRequired = true;
        formMetadata[sectionName].fields[fieldName].isValid = true;
        formMetadata[sectionName].fields[fieldName].status = "";
        zeros = false;
      } else if (income === "") {
        formMetadata[sectionName].fields[fieldName].isRequired = true;
        formMetadata[sectionName].fields[fieldName].isValid = false;
        formMetadata[sectionName].fields[fieldName].status = "";
      }
    }

    formMetadata[sectionName].isValid = this.updateSectionInfo(
      formMetadata[sectionName].fields,
    );
    formMetadata[sectionName].status = "";

    this.setState({
      formMetadata,
      zeroIncomes: zeros,
    });
  };

  updateAddressStatus = (address) => {
    const addr = address;

    for (const addrType in address) {
      if (address.hasOwnProperty(addrType)) {
        const fields = address[addrType];
        for (const field in fields) {
          if (fields.hasOwnProperty(field)) {
            if (field !== "isSameAddr") {
              const f = fields[field];
              if (f.isRequired && !f.isValid && f.status !== "invalid") {
                f.status = "invalid";
              }
            }
          }
        }
      }
    }
    return addr;
  };

  updateFormStatus = () => {
    const { formMetadata } = this.state;

    let mainIncome = "";

    for (const section in formMetadata) {
      if (formMetadata.hasOwnProperty(section)) {
        const fields = formMetadata[section].fields;
        formMetadata[section].isValid = true;
        for (const field in fields) {
          if (fields.hasOwnProperty(field)) {
            if (field !== "address") {
              const f = fields[field];

              if (field === "income") {
                mainIncome = f.value;
              }

              if (f.isRequired && !f.isValid && f.status !== "invalid") {
                f.status = "invalid";
                if (formMetadata[section].status !== "invalid") {
                  formMetadata[section].status = "invalid";
                }
                formMetadata[section].isValid = false;
              }
            }
          }
        }
      }
    }

    formMetadata.sectionAddress.fields.address = this.updateAddressStatus(
      formMetadata.sectionAddress.fields.address,
    );

    this.setState({
      formMetadata,
      hasValidated: true,
      zeroIncomes: mainIncome === "0",
    });
  };

  submitForm = (payload) => {
    const BASE_PATH = "/patientsolutions/app",
      REGISTRATION = "/check-your-rate",
      SUBMIT = "/submit-appl",
      submitURL = BASE_PATH + REGISTRATION + SUBMIT,
      postOpts = {
        timeout: 30000,
        useCsrf: true,
      };

    this.setState({ hasSubmittedBE: true });

    let newFormState = {
      hasSubmittedBE: false,
      hasCompletedBE: false,
      hasErrored: false,
      hasReqTimeout: false,
      hasInvalidFields: false,
      hasErroredUnrecoverable: false,
    };

    httpClient
      .post(submitURL, payload, postOpts)
      .then((response) => {
        newFormState.hasCompletedBE = true;
        this.setState(newFormState);
        window.location.href = response.data.redirectURL;
      })
      .catch((error) => {
        const { response } = error;

        if (response && response.status) {
          const { status } = response;
          if (status === 400) {
            newFormState.hasErrored = true;
          } else if (status === 403) {
            // Could be invalid csrf validation See: https://jira.tlcinternal.com/browse/PF-24188
            newFormState.hasReqTimeout = true;
          } else {
            newFormState.hasErroredUnrecoverable = true;
          }
          this.setState(newFormState);
        } else {
          // handles timeout
          newFormState.hasReqTimeout = true;
          this.setState(newFormState);
        }
      });
  };

  handleSubmit = (ev) => {
    if (this.isValidForm()) {
      const { formMetadata } = this.state,
        { userInfo, clientInfo } = this.props;
      formMetadata.userInfo = userInfo;
      formMetadata.clientInfo = clientInfo;
      this.submitForm(formMetadata);
    } else {
      this.updateFormStatus(); // show errored fields
    }
  };

  renderSubmitMessage() {
    const { updates } = this.props,
      { hasErrored, hasInvalidFields, hasReqTimeout, hasErroredUnrecoverable } =
        this.state;
    let message,
      wrapClass = "pf-registration-subtitle",
      msgProps = {
        className: "pg-subtitle",
      };

    if (
      hasErrored ||
      hasReqTimeout ||
      hasInvalidFields ||
      hasErroredUnrecoverable
    ) {
      msgProps.role = "alert";
    }

    if (hasErrored) {
      wrapClass += " error";
      message = updates.errorMsg;
    } else if (hasInvalidFields) {
      wrapClass += " has-invalid";
      message = updates.invalidFieldsMsg;
    } else if (hasReqTimeout) {
      wrapClass += " error";
      message = updates.errorTimeoutMsg;
    } else if (hasErroredUnrecoverable) {
      wrapClass += " error";
      message = updates.unrecoverableMsg;
    } else {
      wrapClass += " success";
      message = updates.successMsg;
    }

    return (
      <div className={wrapClass}>
        <h3 {...msgProps}>{message}</h3>
      </div>
    );
  }

  renderModal(baseClasses) {
    const { hasSubmittedBE } = this.state,
      modalClass = classnames("modal", baseClasses);

    return (
      <div className={modalClass}>
        <Spinner show={hasSubmittedBE} />
      </div>
    );
  }

  renderForm() {
    const {
        pi1FormId,
        formClasses,
        userInfo,
        clientInfo,
        clientProds,
        shouldCollectEmploymentStatus,
        lockApplicationFeatures,
      } = this.props,
      {
        nameDisabled,
        validForm,
        formMetadata,
        MAStateSelected,
        hasErrored,
        hasValidated,
        hasErroredUnrecoverable,
        hasReqTimeout,
        hasCompletedBE,
        zeroIncomes,
        hasSubmittedBE,
      } = this.state,
      formState = {
        hasErrored,
        hasErroredUnrecoverable,
        hasCompletedBE,
        hasValidated,
        hasSubmittedBE,
        validForm,
        hasReqTimeout,
      },
      formClass = `${pi1FormId} ${formClasses.layout}`;
    return (
      <form
        id={pi1FormId}
        method="post"
        onSubmit={this.handleSubmit}
        className={formClass}
        acceptCharset="utf-8"
      >
        <PI1FormSecAmount
          toggleApplicantName={this.toggleApplicantName}
          sectionMetadata={formMetadata.sectionAmount}
          onSectionCallback={this.handleSectionCallback}
          sectionStatus={formMetadata.sectionAmount.status}
          minLoanAmt={this.state.minLoanAmt}
          maxLoanAmt={this.state.maxLoanAmt}
          MAStateSelected={MAStateSelected}
          MA_minAmt={constants.MA_min_amount.value}
          clientInfo={clientInfo}
          clientProds={clientProds}
          userType={userInfo.userType}
        />
        <PI1FormNameAddress
          nameDisabled={nameDisabled}
          sectionMetadata={formMetadata.sectionAddress}
          onSectionCallback={this.handleSectionCallback}
          sectionStatus={formMetadata.sectionAddress.status}
          onAddrToggleCallback={this.handleAddrToggleCallback}
          onStateChgCallback={this.handleStateChgCallback}
          loanAmount={formMetadata.sectionAmount.fields.loanAmount.value}
          MA_minAmt={constants.MA_min_amount.value}
          useMinAmountForMA={clientProds.useMinAmountForMA}
        />
        <PI1FormSecDetails
          hasAutoFilled={this.state?.hasAutoFilled}
          shouldCollectEmploymentStatus={shouldCollectEmploymentStatus}
          sectionMetadata={formMetadata.sectionDetails}
          onSectionCallback={this.handleSectionCallback}
          sectionStatus={formMetadata.sectionDetails.status}
          userInfo={userInfo}
          clientInfo={clientInfo}
          updateAsyncState={this.updateAsyncState}
          zeroIncomes={zeroIncomes}
          formState={formState}
        />
        <Disclosures
          sectionMetadata={formMetadata.sectionDisclosures}
          onSectionCallback={this.handleSectionCallback}
          sectionStatus={formMetadata.sectionDisclosures.status}
          clientInfo={clientInfo}
          userType={userInfo.userType}
        />
        <PI1FormSecActions
          handleSubmit={this.handleSubmit}
          formState={formState}
          formStatus={validForm}
          lockApplicationFeatures={lockApplicationFeatures}
        />
      </form>
    );
  }

  render() {
    const { pi1FormId, formClasses } = this.props,
      {
        hasSubmittedBE,
        hasErrored,
        hasReqTimeout,
        hasErroredUnrecoverable,
        hasCompletedBE,
        hasInvalidFields,
      } = this.state,
      displaySubmitMessage =
        hasErrored ||
        hasReqTimeout ||
        hasErroredUnrecoverable ||
        hasInvalidFields ||
        hasCompletedBE,
      displayModal = hasSubmittedBE,
      baseClasses = {
        [`${formClasses.hasSubmitted}`]: hasSubmittedBE,
        [`${formClasses.hasErrored}`]:
          hasErrored || hasReqTimeout || hasErroredUnrecoverable,
        [`${formClasses.hasCompleted}`]: hasCompletedBE,
        [`${formClasses.hasInvalidFields}`]: hasInvalidFields,
      },
      wrapClass = `${pi1FormId}-wrap`;

    return (
      <div className={wrapClass}>
        {displaySubmitMessage && this.renderSubmitMessage()}
        {this.renderForm()}
        {displaySubmitMessage && this.renderSubmitMessage()}
        {displayModal && this.renderModal(baseClasses)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo,
    clientInfo: state.clientInfo,
    clientProds: state.clientProds,
    siteConfig: state.siteConfig,
    errors: state.errors,
    shouldCollectEmploymentStatus: state.shouldCollectEmploymentStatus,
    lockApplicationFeatures: state.lockApplicationFeatures,
  };
};

PI1FormReact.propTypes = {
  shouldCollectEmploymentStatus: PropTypes.bool.isRequired,
  userInfo: PropTypes.object,
  clientInfo: PropTypes.object.isRequired,
  clientProds: PropTypes.object.isRequired,
  siteConfig: PropTypes.object,
  errors: PropTypes.object,
  pi1FormId: PropTypes.string.isRequired,
  formClasses: PropTypes.object.isRequired,
  updates: PropTypes.object.isRequired,
  defaultValues: PropTypes.object,
  lockApplicationFeatures: PropTypes.bool.isRequired,
};

const PI1Form = connect(mapStateToProps)(PI1FormReact);

export { PI1FormReact };
export default PI1Form;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');